import { Component, Input } from '@angular/core';
import { Contact, SalesOrganisationInfo } from '../../../../core/store/customer-info/customer-info.interface';

@Component({
  selector: 'app-local-office-tile',
  templateUrl: './local-office-tile.component.html',
  styleUrls: ['../common/orders-flows-tile.component.scss', './local-office-tile.component.scss'],
})
export class LocalOfficeTileComponent {
  @Input() salesOrganisation: SalesOrganisationInfo;
}
